import React, { FC } from "react";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";

interface UploadDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UploadDialog: FC<UploadDialogProps> = ({ isOpen, onClose, onUpload }) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Upload Files</DialogTitle>
      <DialogContent>
        <input type="file" multiple onChange={onUpload} style={{ marginBottom: "10px" }} />
        <Button onClick={onClose}>Close</Button>
      </DialogContent>
    </Dialog>
  );
};

export default UploadDialog;